import React from "react";
import ProductReferenceResponse from "../../../../api/models/ProductReferenceResponse";
import { AutocompleteSelectable } from "../../../../components/Autocomplete/CustomSearchAutoComplete";
import { ProductsAutocomplete } from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import ProductEditData from "../ProductEditData.model";
import { CompetitorProductReferenceResponse } from "../../../../api/models/CompetitorProductReference";
import { PrototypeProductReferenceResponse } from "../../../../api/models/PrototypeProductReference";

interface ProductsInputProps {
  mandatory?: boolean;
  error?: boolean;
  helperText?: string | undefined;
  disabled?: boolean;
  label: string;
  values: ProductReferenceResponse[];
  onDelete?: (
    item: AutocompleteSelectable<
      ProductReferenceResponse | CompetitorProductReferenceResponse | PrototypeProductReferenceResponse
    >,
    index: number,
  ) => void;
  onReset: () => void;
  onTagClick?: (productEditData: ProductEditData<any>) => void;
}

const ProductsInput: React.FC<ProductsInputProps> = ({
  mandatory,
  error,
  helperText,
  disabled,
  label,
  onDelete,
  onReset: handleReset,
  onTagClick: handleTagClick,
  values,
}) => {
  return (
    <ProductsAutocomplete
      mandatory={mandatory}
      helperText={helperText}
      error={error}
      disabled={disabled}
      disabledTextEntry
      getCustomTagDelete={(item, index) => ({
        onDelete: () => onDelete?.(item, index),
      })}
      inputLabel={label}
      map={(data, idx) => {
        let name = "";
        switch (true) {
          case Boolean(data.nart):
            name = data?.nart || "";
            break;
          case Boolean(data.baseProduct):
            name = data?.baseProduct || "";
            break;
          case Boolean(data.productName):
            name = data?.productName || "";
            break;
          default:
            name = data?.name || "";
            break;
        }
        return { key: name + idx, label: name };
      }}
      onChange={(e, val) => {
        if (!val.length) {
          handleReset();
        }
      }}
      onTagClick={handleTagClick}
      optionFetch={() => {
        return Promise.resolve({
          data: [],
          totalPages: 0,
        });
      }}
      value={values}
    />
  );
};

export default ProductsInput;
